/** Retorna a diferença entre duas datas no formato "H:MM" (horas:minutos). */
export const getTimeDifference = (firstDate: string, secondDate: string): string => {
  const diffMs = Math.abs(new Date(firstDate).getTime() - new Date(secondDate).getTime());
  const totalMinutes = Math.floor(diffMs / 60_000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}:${String(minutes).padStart(2, '0')}`;
};

/** Retorna uma frase de tempo relativo em pt-BR (ex: "há 5 min", "há 2 dias"). */
export const getElapsedTimePhrase = (time: string | Date | null | undefined): string | undefined => {
  if (!time) return undefined;

  const ms = new Date(time).getTime();
  if (Number.isNaN(ms)) return undefined;

  const elapsed = Math.abs(Date.now() - ms);

  if (elapsed < 60_000) return 'agora';

  const minutes = Math.round(elapsed / 60_000);
  if (minutes < 60) return `há ${minutes} min`;

  const hours = Math.round(elapsed / 3_600_000);
  if (hours < 24) return `há ${hours} ${hours > 1 ? 'horas' : 'hora'}`;

  const days = Math.round(elapsed / 86_400_000);
  if (days < 7) return `há ${days} ${days > 1 ? 'dias' : 'dia'}`;

  const weeks = Math.round(elapsed / 604_800_000);
  if (weeks < 4) return `há ${weeks} ${weeks > 1 ? 'semanas' : 'semana'}`;

  const months = Math.round(elapsed / 2_592_000_000);
  if (months < 12) return `há ${months} ${months > 1 ? 'meses' : 'mês'}`;

  const years = Math.round(elapsed / 31_104_000_000);
  return `há ${years} ${years > 1 ? 'anos' : 'ano'}`;
};

/** Formata data para exibição no chat: hora se hoje, data numérica se outro dia. */
export const formatChatDate = (rawDate: string, today: string | Date): string => {
  const date = new Date(rawDate);
  const isToday = date.toDateString() === new Date(today).toDateString();
  const options: Intl.DateTimeFormatOptions = isToday
    ? { hour: 'numeric', minute: 'numeric', hour12: false }
    : { month: 'numeric', year: 'numeric', day: 'numeric', hour12: false };
  return date.toLocaleString('pt-BR', options);
};
